import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import { useSelector } from "react-redux";
import { useGlobalContext } from "store/contexts/globalContext";
import TeamWithMembers from "components/TeamWithMembers";
import classNames from "classnames";
import "assets/scss/partials/chat.scss";
import Chat from "components";
import Scrollbar from "react-scrollbars-custom";
import { useHistory, useLocation } from "react-router-dom";

const useStyle = {
  noActiveChat: {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
  },
  noActiveText: {
    color: "#575f6b",
    fontSize: "22px",
    fontWeight: "500",
  },
  noMemberAvailable: {
    display: "flex",
    justifyContent: "center",
    fontSize: "large",
    fontWeight: 500,
    paddingTop: "100px",
    textAlign: "center",
  },
};

export default () => {
  const classes = useStyle;
  const { loading } = useGlobalContext();
  const history = useHistory();
  const { userData } = useLocation();
  const [teams, setTeams] = useState([]);
  const teamsReducer = useSelector((state) =>
    state.teamsReducer.teams.filter((team) => team.users.length > 1)
  );
  const [displayText, setDisplayText] = useState(false);
  const [loader, setLoader] = useState(false);
  const [userId, setUserId] = useState(null);
  const [mobileShow] = useState(
    window.matchMedia("(max-width: 991px)").matches ? true : false
  );
  const [showChatBox, setShowChatBox] = useState(!mobileShow ? true : false);

  const handleChat = (id, teamId = null) => {
    if (mobileShow) {
      history.push(`/private-chat/${id}/chat`);
      return;
    }

    if (userId !== id) {
      setUserId(id);
    }
    if (teamId) {
      moveTeamToTop(teamId, id);
    }
    setShowChatBox(true);
  };

  useEffect(() => {
    if (teams.length > 0) {
      setTimeout(() => {
        setDisplayText(true);
      }, 500);

      return;
    }

    if (teamsReducer.length !== 0) {
      setTeams(teamsReducer);
    }

    //eslint-disable-next-line
  }, [teamsReducer]);

  useEffect(() => {
    if (!userData) {
      return;
    }

    setUserId(userData.user_id);
    if (userData.team_id) {
      moveTeamToTop(userData.team_id);
    }
    setShowChatBox(true);

    //eslint-disable-next-line
  }, [userData]);

  const moveTeamToTop = (teamId, userId = null) => {
    const teamData = teams.filter((team) => team.id === teamId);
    if (userId) {
      var userDataCopy = teamData[0].users.filter(
        (member) => member.id === userId
      );
      var userIndex = teamData[0].users.indexOf(userDataCopy[0]);
      teamData[0].users.splice(userIndex, 1);
      teamData[0].users.splice(0, 0, userDataCopy[0]);
    }
    const teamIndex = teams.indexOf(teamData[0]);
    teams.splice(teamIndex, 1);
    teams.splice(0, 0, teamData[0]);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {loading && <Loader />}
      </div>
      {teams.length === 0 && !loading && (
        <div style={classes.noMemberAvailable}>
          There isn't any member available for the chat
        </div>
      )}
      <div style={{ display: "flex" }}>
        <Scrollbar
          translateContentSizeYToHolder={true}
          disableTracksWidthCompensation={true}
          removeTracksWhenNotUsed={true}
          className={classNames({
            reactScrollbar: true,
            reactScrollbarActive: showChatBox ? true : false,
          })}
        >
          <div
            className={classNames({
              chatLeftSection: true,
              chatbox: showChatBox,
            })}
          >
            {teams?.map((team) => (
              <TeamWithMembers
                userId={userId}
                key={team?.id}
                team={team}
                loader={loader}
                showChatBox={showChatBox}
                handleChat={handleChat}
              />
            ))}
          </div>
        </Scrollbar>
        <div
          className={classNames({
            chatRightSection: true,
            chatSection: showChatBox,
          })}
        >
          {!userId && !loading && !mobileShow && displayText && (
            <div style={classes.noActiveChat}>
              <span style={classes.noActiveText}>
                You don't have any active chat.
              </span>
            </div>
          )}
          {!mobileShow && (
            <Chat
              handleChat={handleChat}
              userId={userId}
              loader={loader}
              setLoader={setLoader}
            />
          )}
        </div>
      </div>
    </div>
  );
};
